// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SPEC_wrapper__1p1Lf"};